const ERROR_MESSAGES = {
	ELEMENT_NOT_FOUND: 'TextSlider: Required elements not found',
	INIT_FAILED: 'TextSlider: Initialization failed',
	SLIDE_NOT_FOUND: 'TextSlider: Slide not found',
	SLIDER_NOT_FOUND: 'TextSlider: Slider data not found'
};

const CONFIG = {
	ANIMATION: {
		DURATION: 500
	},
	CLASSES: {
		HIDDEN: 'hidden'
	}
};

/**
 * Show a specific slide in the text slider
 * @param {number} index - The index of the slide to show
 * @param {string} sliderId - The ID of the slider
 * @returns {void}
 */
const showTextSlide = (index, sliderId) => {
	try {
		const sliderData = window[`textSlider${sliderId}`];
		const slide = sliderData?.slides[index];

		if (!slide) {
			console.warn(ERROR_MESSAGES.SLIDE_NOT_FOUND);
			return;
		}

		// Update text content
		const tagline = document.getElementById(`tagline-${sliderId}`);
		const headline = document.getElementById(`headline-${sliderId}`);
		const text = document.getElementById(`text-${sliderId}`);
		const link = document.getElementById(`link-${sliderId}`);
		const image = document.getElementById(`image-${sliderId}`);

		if (!tagline || !headline || !text) {
			console.warn(ERROR_MESSAGES.ELEMENT_NOT_FOUND);
			return;
		}

		tagline.innerText = slide.tagline || '';
		headline.innerHTML = slide.headline || '';
		text.innerHTML = slide.text || '';

		// Update optional elements if they exist
		if (link) {
			link.href = slide.link || '#';
			link.innerText = slide.linkText || '';
		}

		if (image) {
			image.src = slide.image || '';
		}
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

/**
 * Change to the next or previous slide
 * @param {number} direction - The direction to change slides (1 for next, -1 for previous)
 * @param {string} sliderId - The ID of the slider
 * @returns {void}
 */
const changeTextSlide = (direction, sliderId) => {
	try {
		const sliderData = window[`textSlider${sliderId}`];
		
		if (!sliderData?.slides) {
			console.warn(ERROR_MESSAGES.SLIDER_NOT_FOUND);
			return;
		}

		const content = document.querySelector(`#text-slider-${sliderId} .text-slider__content`);
		const slider = document.querySelector(`#text-slider-${sliderId} .text-slider__slider-preview > img`);

		// Hide content for transition
		if (content) content.classList.add(CONFIG.CLASSES.HIDDEN);
		if (slider) slider.classList.add(CONFIG.CLASSES.HIDDEN);

		// Calculate new slide index
		sliderData.currentSlide += direction;
		if (sliderData.currentSlide < 0) {
			sliderData.currentSlide = sliderData.slides.length - 1;
		} else if (sliderData.currentSlide >= sliderData.slides.length) {
			sliderData.currentSlide = 0;
		}

		// Show new slide after animation
		setTimeout(() => {
			showTextSlide(sliderData.currentSlide, sliderId);
			if (content) content.classList.remove(CONFIG.CLASSES.HIDDEN);
			if (slider) slider.classList.remove(CONFIG.CLASSES.HIDDEN);
		}, CONFIG.ANIMATION.DURATION);
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

/**
 * Initialize text slider functionality
 * @returns {void}
 */
const initializeTextSlider = () => {
	try {
		// The initialization is handled by the global window.textSlider objects
		// and the showTextSlide/changeTextSlide functions
		// This function exists for consistency with the module pattern
	} catch (error) {
		console.error(ERROR_MESSAGES.INIT_FAILED, error);
	}
};

export { initializeTextSlider, showTextSlide, changeTextSlide };
